/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactsSectionGenerated } from './ContactsSectionGenerated';
import {
    ContactsSectionGeneratedFromJSON,
    ContactsSectionGeneratedFromJSONTyped,
    ContactsSectionGeneratedToJSON,
} from './ContactsSectionGenerated';

/**
 * 
 * @export
 * @interface ContactsSection
 */
export interface ContactsSection {
    /**
     * 
     * @type {string}
     * @memberof ContactsSection
     */
    type: ContactsSectionTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ContactsSection
     */
    parameters: object;
    /**
     * 
     * @type {ContactsSectionGenerated}
     * @memberof ContactsSection
     */
    generated: ContactsSectionGenerated;
}


/**
 * @export
 */
export const ContactsSectionTypeEnum = {
    Contacts: 'CONTACTS'
} as const;
export type ContactsSectionTypeEnum = typeof ContactsSectionTypeEnum[keyof typeof ContactsSectionTypeEnum];


/**
 * Check if a given object implements the ContactsSection interface.
 */
export function instanceOfContactsSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "parameters" in value;
    isInstance = isInstance && "generated" in value;

    return isInstance;
}

export function ContactsSectionFromJSON(json: any): ContactsSection {
    return ContactsSectionFromJSONTyped(json, false);
}

export function ContactsSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactsSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'parameters': json['parameters'],
        'generated': ContactsSectionGeneratedFromJSON(json['generated']),
    };
}

export function ContactsSectionToJSON(value?: ContactsSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'parameters': value.parameters,
        'generated': ContactsSectionGeneratedToJSON(value.generated),
    };
}

